import { ExclamationCircleFilled } from '@ant-design/icons'
import { Alert, Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import SpeakerIcon from 'components/icons/SpeakerIcon'
import { Text } from 'modules/Onboarding/Register/WorkExperience/style'
import { AdjustIcon } from 'modules/Resume/DrawerComponents/DrawerStyle'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import CheckIconBlue from '../../../components/icons/CheckIconBlue'
import CheckIconGreen from '../../../components/icons/CheckIconGreen'
import CheckIconGrey from '../../../components/icons/CheckIconGrey'
import ThumbsUpIcon from '../../../components/icons/ThumbsUpIcon'
import FilterCheckBoxComp from '../../../components/UIElements/FilterCheckBoxComp'
import { FlexWrapRole, StyledDrawerSkill } from './style'

import Checkbox from 'components/CheckboxSkill/Checkbox'
import CrossIconSkill from 'components/icons/CrossIconSkill'
import { useDispatch } from 'react-redux'
import CheckboxSelectAll from '../../../components/CheckboxSelectAll/CheckboxSelectAll'
import { StyledDiv } from '../../Dashboard/Style/style'
import { getStudentData } from '../../Resume/actions'
import {
  AddedSkillHeading,
  AddSkillHeading,
  ButtonLocal,
  CarouselContainer,
  ContentStyle,
  ContentStyleNew,
  CountHeading,
  ExperienceDescription,
  ExperienceNote,
  ExtraPadding,
  ExtraPaddingLast,
  ExtraPaddingLeft,
  ExtraPaddingLeftSkill,
  ExtraPaddingLeftSkill1,
  ExtraPaddingNew,
  ExtraPaddingSkills,
  FooterFixed,
  HeaderFixed,
  HeaderFixedNew,
  HorizontalDivider,
  HorizontalDividerTitle,
  LocationDescription,
  LocationNote,
  SkillHeading,
  SkillSetHeading,
  SkillsHeading,
  SkillsHeadingPadding,
  SkillsSubHeading,
  SpinWrapper,
  TopHeading,
  UpdateContent,
  VerticalDivider,
} from './roleStyle'

const SkillBasedRoleDrawer = ({
  roleDrawer,
  selectedNew,
  setRoleDrawer,
  eligibleList,
  getEligibleDetails,
  roleFloatList,
  itemId,
  setLoading,
  loading,
  setWorkExperienceDrawer,
  updateRoleFloatDetails,
  formId = 'role_drawer',
  UpdatedSkills,
  skillVisible,
  locationVisible,
  expVisible,
  expDrawer,
  setUpdateResponse,
  updateResponse,
  setQuestionnaireModal,
  setSelected,
  onApplyClick,
  fetchEligleDetails,
  eligibilityCriteria,
}) => {
  const dispatch = useDispatch()

  const [selectedLocation, setSelectedLocation] = useState([])
  const [combinedArrayLocation, setCombinedArrayLocation] = useState([])
  const [selectedEdu, setSelectedEdu] = useState([])
  const [selectedWork, setSelectedWork] = useState([])
  const [selectedIntern, setSelectedIntern] = useState([])
  const [selectedTraining, setSelectedTraining] = useState([])
  const [showComponent, setShowComponent] = useState(false)
  const [selectedProject, setSelectedProject] = useState([])
  const [educationCheck, setEducationCheck] = useState(false)
  const [projectCheck, setProjectCheck] = useState(false)
  const [internCheck, setInternCheck] = useState(false)
  const [workCheck, setWorkCheck] = useState(false)
  const [trainingCheck, setTrainingCheck] = useState(false)
  const [educationList, setEducationList] = useState([])
  const [workList, setWorkList] = useState([])
  const [projectList, setProjectList] = useState([])
  const [trainingList, setTrainingList] = useState([])
  const [internList, setInternList] = useState([])
  const [allLocationsAdded, setAllLocationsAdded] = useState(true)

  const [preferredLocationsString, setPreferredLocationsString] = useState('')
  const [requiredLocations, setRequiredLocations] = useState('')
  const [experienceFromDate, setExperienceFromDate] = useState('')
  const [experienceToDate, setExperienceToDate] = useState('')
  const [checked, setChecked] = useState(false)
  const [added, setAdded] = useState(false)
  const [addSkills, setAddSkills] = useState(false)
  const [studentExperience, setStudentExperience] = useState('')
  const [addedSkills, setAddedSkills] = useState([])
  const [addedAllSkills, setAddedAllSkills] = useState([])
  const [addedSkill, setAddedSkill] = useState([])
  const [addingSkill, setAddingSkill] = useState(null)
  const [addSkillDisable, setAddSkillDisable] = useState(false)
  const [add, setAdd] = useState(false)
  useEffect(() => {
    const preferredLocationsString = eligibleList?.locations?.studentLocation
      ?.map(loc => loc?.city_name ?? loc?.state_name)
      ?.join(', ')

    const requiredLocations = eligibleList?.locations?.allLocations
      ?.map(item => item?.name ?? item?.state_name)
      .join(', ')

    const experienceFromDate = eligibleList?.experience?.fromYear
    const experienceToDate = eligibleList?.experience?.toYear
    const studentExperience = eligibleList?.experience?.studentExperience

    setPreferredLocationsString(preferredLocationsString)
    setRequiredLocations(requiredLocations)
    setExperienceFromDate(experienceFromDate)
    setExperienceToDate(experienceToDate)
    setStudentExperience(studentExperience)
  }, [eligibleList])

  useEffect(() => {
    const data = eligibleList?.locations?.allLocations?.every(
      location => location?.isAdded
    )
    setAllLocationsAdded(data)
  }, [eligibleList])

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowComponent(true)
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    let uniqueArray = []

    eligibleList?.locations?.allLocations?.forEach(value => {
      if (value?.isAdded) {
        uniqueArray.push(value?.id)
      }
    })
    setSelectedLocation(uniqueArray)
  }, [eligibleList])

  const clearSelectedList = () => {
    setSelectedEdu([])
    setSelectedWork([])
    setSelectedTraining([])
    setSelectedProject([])
    setSelectedIntern([])
  }

  const onCheckboxEdu = list => {
    setSelectedEdu(list)
  }

  const onCheckboxWork = list => {
    setSelectedWork(list)
  }

  const onCheckboxTraining = list => {
    setSelectedTraining(list)
  }

  const onCheckboxProject = list => {
    setSelectedProject(list)
  }
  const onCheckboxIntern = list => {
    setSelectedIntern(list)
  }

  const onCheckboxLocation = list => {
    const filteredObjects = eligibleList?.locations?.allLocations?.filter(
      item => list?.includes(item?.id ?? item?.state_id) && !item?.isAdded
    )
    const locationList = filteredObjects?.map(item => {
      const obj = {};
    
      if (item?.id) obj.city_id = item?.id;
      if (item?.state_id) obj.state_id = item?.state_id;
      if (item?.state_name) obj.state_name = item?.state_name;
      if (item?.name) obj.city_name = item?.name;
    
      return obj;
    });

    setSelectedLocation(list)
    setChecked(list?.length === eligibleList?.locations?.allLocations?.length)

    return locationList
  }

  useEffect(() => {
    const locationList = onCheckboxLocation(selectedLocation)

    const combinedLocation = [locationList]
      .flat()
      .map(item => ({ ...item, selected: false }))
    setCombinedArrayLocation(combinedLocation)
  }, [selectedLocation])

  const onClear = () => {
    setRoleDrawer(false)
    UpdatedSkills()
  }

  const onClearSkill = () => {
    setEducationCheck(false)
    setProjectCheck(false)
    setInternCheck(false)
    setTrainingCheck(false)
    setWorkCheck(false)

    const filteredAddedSkill = addedSkill?.filter(
      skill => !addedSkills?.some(added => added?.id === skill?.id)
    )

    setAddedSkill(filteredAddedSkill)
    setAdded(false)
    setAddSkillDisable(false)
    setAddingSkill(null)
  }

  const click = () => {
    dispatch(getStudentData())
    setWorkExperienceDrawer(true)
  }

  const handleAddSkillClick = item => {
    const newSkill = {
      ...item,
    }
    setAddedSkills(() => [newSkill])
    setAddedSkill(prevAllSkills => [...prevAllSkills, newSkill])
    setAdded(true)
    setAddingSkill(item)
    setAddSkillDisable(true)
    setAdd(false)
  }

  const handleEducationCheck = e => {
    setSelectedEdu([])
    setEducationCheck(e.target.checked)
    setEducationList(
      roleFloatList?.academics?.filter(item => item.educationLevel)
    )
  }

  const handleWorkCheck = e => {
    setSelectedWork([])
    setWorkCheck(e.target.checked)
    setWorkList(roleFloatList?.workExperience?.filter(item => item.id))
  }

  const handleInternshipCheck = e => {
    setSelectedIntern([])
    setInternCheck(e.target.checked)
    setInternList(roleFloatList?.internships?.filter(item => item.id))
  }

  const handleTrainingCheck = e => {
    setSelectedTraining([])
    setTrainingCheck(e.target.checked)
    setTrainingList(roleFloatList?.courses?.filter(item => item.id))
  }

  const handleProjectCheck = e => {
    setSelectedProject([])
    setProjectCheck(e.target.checked)
    setProjectList(roleFloatList?.projects?.filter(item => item.id))
  }

  const SubmitDataSkill = async () => {
    setEducationCheck(false)
    setProjectCheck(false)
    setInternCheck(false)
    setTrainingCheck(false)
    setWorkCheck(false)
    const skillDetails = addedSkills?.map(item => {
      return {
        id: item?.id,
        name: item?.name,
        academics: selectedEdu,
        projects: selectedProject,
        courses: selectedTraining,
        workExperience: selectedWork,
        internships: selectedIntern,
        training: [],
      }
    })

    let payload = {
      skillDetails: [...skillDetails],
      locations: [],
      checkForApproval: true,
      checkDeleteSection: ['education', 'projects', 'workExperience', 'internships', 'courses'],
    }

    let response = await updateRoleFloatDetails(payload, itemId)

    if (response?.status == 200) {
      setUpdateResponse(
        response?.data?.data?.eligibleDetails?.skills?.isEligible
      )
      SuccessMessage('Skills added successfully!')
      setAdded(false)
      setAddedAllSkills(addedSkill)
      setAdd(true)
      setAddSkills(true)
      setAddSkillDisable(false)
      fetchEligleDetails()
      clearSelectedList()
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const SubmitDataLocation = async () => {
    const locationDetails = combinedArrayLocation?.map(item => {
      return item
    })

    let payload = {
      skillDetails: [],
      locations: [...locationDetails],
      checkForApproval: true,
      checkDeleteSection: ['studentPersonalProfile'],
    }

    let response = await updateRoleFloatDetails(payload, itemId)
    if (response?.status == 200) {
      let resultData = await fetchEligleDetails()
      let res = await getEligibleDetails({ roleID: itemId, setLoading })

      if (res?.isEligible && resultData?.isEligible) {
        if (selectedNew?.questionBankRoleMap?.length) {
          setRoleDrawer(false)
          setSelected(selectedNew)
          setQuestionnaireModal(true)
        } else if (selectedNew?.roleId) {
          console.log('clicked apply')
          setRoleDrawer(false)
          onApplyClick(selectedNew)
        } else {
          SuccessMessage('Updated Successfully!')
          setRoleDrawer(false)
          UpdatedSkills()
        }
      } else {
        ErrorMessage('Still you are not eligible to apply the role')
        setRoleDrawer(false)
        UpdatedSkills()
      }
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const content = () => {
    const handleCheck = e => {
      const newChecked = e.target.checked
      setChecked(newChecked)

      if (newChecked) {
        const allLocationIds = eligibleList?.locations?.allLocations.map(
          item => item.id
        )
        setSelectedLocation(allLocationIds)
      } else {
        setSelectedLocation([])
      }
    }

    const isSkillsEligible =
      updateResponse === false && !eligibleList?.skills?.isEligible
    const isLocationEligible = !eligibleList?.locations?.isEligible
    const isExperienceEligible = !eligibleList?.experience?.isEligible

    const hasEligibilityIssue =
      isSkillsEligible || isLocationEligible || isExperienceEligible

    let message = ''

    const hasNonEmptySkillSet = eligibleList?.skills?.otherMandatory?.some(
      skillSet => skillSet?.skills?.length > 0
    )
    if (hasEligibilityIssue) {
      if (isSkillsEligible && isLocationEligible && isExperienceEligible) {
        message = 'skills, location, and work experience'
      } else if (isSkillsEligible && isLocationEligible) {
        message = 'skills and location'
      } else if (isSkillsEligible && isExperienceEligible) {
        message = 'skills and work experience'
      } else if (isLocationEligible && isExperienceEligible) {
        message = 'location and work experience'
      } else {
        if (isSkillsEligible) {
          message += 'skills'
        }
        if (isLocationEligible) {
          if (message) message += ' and '
          message += 'location'
        }
        if (isExperienceEligible) {
          if (message) message += ' and '
          message += 'work experience'
        }
      }

      message = `Due to a lack of matching ${message}, you are not eligible to apply for this role.`
    }
    const locationList = eligibleList?.locations?.allLocations?.map(item => ({
      id: item?.id ?? item?.state_id,
      name: item?.name ?? item?.state_name,
      isAdded: false,
    }))
    return (
      <>
        {loading && (
          <SpinWrapper center>
            <Spin />
          </SpinWrapper>
        )}
        {!loading && (
          <>
            {!showComponent && (
              <SpinWrapper center>
                <Spin />
              </SpinWrapper>
            )}
            <div style={{ display: 'flex', width: '100%' }}>
              {showComponent && (
                <>
                  <div style={{ width: added ? '50%' : '100%' }}>
                    <HeaderFixed>
                      <FlexWrapRole centerVertically gap="20px">
                        {!updateResponse ||
                        !eligibleList?.locations?.isEligible ||
                        !eligibleList?.experience?.isEligible ? (
                          <>
                            <ExclamationCircleFilled
                              style={{ fontSize: '20px', color: '#E35E50' }}
                            />
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: '16px',
                                lineHeight: '25px',
                                color: '#343E59',
                              }}
                            >
                              {message}
                            </div>
                            <StyledDiv onClick={onClear}>
                              <CrossIconSkill />
                            </StyledDiv>
                          </>
                        ) : (
                          <>
                            {eligibilityCriteria?.isEligible ? (
                              <>
                                <ThumbsUpIcon />
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: '16px',
                                    lineHeight: '25px',
                                    color: '#343E59',
                                  }}
                                >
                                  {'Now you are eligible to apply this role !'}
                                </div>
                                <ExtraPaddingLeft />
                              </>
                            ) : (
                              <>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: '16px',
                                    lineHeight: '25px',
                                    color: '#343E59',
                                    display: 'none',
                                  }}
                                >
                                  {message}
                                </div>
                              </>
                            )}

                            <StyledDiv onClick={onClear}>
                              <CrossIconSkill />
                            </StyledDiv>
                          </>
                        )}
                      </FlexWrapRole>
                      <HorizontalDivider
                        style={{ marginTop: '12px', marginBottom: '10px' }}
                      />
                    </HeaderFixed>
                    <ContentStyle>
                      <div
                        style={{
                          paddingLeft: '25px',
                          paddingTop: '20px',
                          paddingRight: '10px',
                        }}
                      >
                        {!skillVisible && (
                          <>
                            <SkillsHeading>Skills</SkillsHeading>
                            {eligibleList?.skills?.primary?.skills?.length >
                              0 && (
                              <>
                                <SkillsSubHeading style={{ display: 'inline' }}>
                                  Primary Mandatory Skills{' '}
                                </SkillsSubHeading>
                                {eligibleList?.skills?.primary?.type == 'AND' &&
                                eligibleList?.skills?.primary?.skills?.length >
                                  1 ? (
                                  <CountHeading style={{ display: 'inline' }}>
                                    (All{' '}
                                    {
                                      eligibleList?.skills?.primary?.skills
                                        ?.length
                                    }{' '}
                                    skills are mandatory)
                                  </CountHeading>
                                ) : eligibleList?.skills?.primary?.type ==
                                    'OR' &&
                                  eligibleList?.skills?.primary?.skills
                                    ?.length > 1 ? (
                                  <CountHeading style={{ display: 'inline' }}>
                                    (Any 1 skill is mandatory)
                                  </CountHeading>
                                ) : eligibleList?.skills?.primary?.skills
                                    ?.length == 1 &&
                                  (eligibleList?.skills?.primary?.type ==
                                    'AND' ||
                                    eligibleList?.skills?.primary?.type ==
                                      'OR') ? (
                                  <CountHeading style={{ display: 'inline' }}>
                                    (The below skill is mandatory)
                                  </CountHeading>
                                ) : (
                                  ''
                                )}
                                <SkillsHeadingPadding />
                              </>
                            )}
                            {eligibleList?.skills?.primary?.skills?.map(
                              (item, index) => {
                                const isSkillAdded = addedAllSkills?.some(
                                  addedItem => addedItem?.id === item?.id
                                )

                                return (
                                  <ExtraPaddingLeftSkill key={index + 'skills'}>
                                    <TopHeading
                                      isAdded={addingSkill === item && !add}
                                      key={item?.id}
                                      disable={
                                        (addSkillDisable &&
                                          addingSkill != item) ||
                                        (addSkills && isSkillAdded) ||
                                        item?.isAdded
                                      }
                                    >
                                      <div>
                                        {item?.isAdded ? (
                                          <CheckIconBlue />
                                        ) : addSkills && isSkillAdded ? (
                                          <CheckIconGreen />
                                        ) : (
                                          <CheckIconGrey />
                                        )}
                                      </div>
                                      <SkillHeading
                                        color={
                                          item?.isAdded ? '#3249D7' : '#343E59'
                                        }
                                      >
                                        {item?.name}
                                      </SkillHeading>
                                      {item?.isAdded ? null : addSkills &&
                                        isSkillAdded ? (
                                        <AddedSkillHeading
                                          style={{
                                            display: 'inline',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          Added
                                        </AddedSkillHeading>
                                      ) : (
                                        <AddSkillHeading
                                          onClick={() =>
                                            !addSkillDisable &&
                                            handleAddSkillClick(item)
                                          }
                                          isAdded={addingSkill === item}
                                          disable={
                                            addSkillDisable &&
                                            addingSkill != item
                                          }
                                          style={{
                                            display: 'inline',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          + Add Skill
                                        </AddSkillHeading>
                                      )}
                                    </TopHeading>
                                  </ExtraPaddingLeftSkill>
                                )
                              }
                            )}
                            <ExtraPaddingNew />

                            {eligibleList?.skills?.secondary?.skills?.length >
                              0 && (
                              <>
                                <SkillsSubHeading style={{ display: 'inline' }}>
                                  Secondary Mandatory Skills
                                </SkillsSubHeading>
                                {eligibleList?.skills?.secondary?.count ==
                                  eligibleList?.skills?.secondary?.skills
                                    ?.length &&
                                eligibleList?.skills?.secondary?.skills
                                  ?.length > 1 ? (
                                  <CountHeading style={{ display: 'inline' }}>
                                    (All{' '}
                                    {eligibleList?.skills?.secondary?.count}{' '}
                                    skills are mandatory)
                                  </CountHeading>
                                ) : eligibleList?.skills?.secondary?.skills
                                    ?.length >
                                    eligibleList?.skills?.secondary?.count &&
                                  eligibleList?.skills?.secondary?.count > 1 ? (
                                  <CountHeading style={{ display: 'inline' }}>
                                    (Any{' '}
                                    {eligibleList?.skills?.secondary?.count}{' '}
                                    skills are mandatory)
                                  </CountHeading>
                                ) : eligibleList?.skills?.secondary?.skills
                                    ?.length >
                                    eligibleList?.skills?.secondary?.count &&
                                  eligibleList?.skills?.secondary?.count ==
                                    1 ? (
                                  <CountHeading style={{ display: 'inline' }}>
                                    (Any{' '}
                                    {eligibleList?.skills?.secondary?.count}{' '}
                                    skill is mandatory)
                                  </CountHeading>
                                ) : eligibleList?.skills?.secondary?.count ==
                                    1 &&
                                  eligibleList?.skills?.secondary?.skills
                                    ?.length == 1 ? (
                                  <CountHeading style={{ display: 'inline' }}>
                                    (The below skill is mandatory)
                                  </CountHeading>
                                ) : (
                                  ''
                                )}
                                <SkillsHeadingPadding />
                              </>
                            )}

                            {eligibleList?.skills?.secondary?.skills?.map(
                              (item, index) => {
                                const isSkillAdded = addedAllSkills.some(
                                  addedItem => addedItem?.id === item?.id
                                )

                                return (
                                  <ExtraPaddingLeftSkill key={index + 'skill'}>
                                    <TopHeading
                                      isAdded={addingSkill === item && !add}
                                      key={item?.id}
                                      disable={
                                        (addSkillDisable &&
                                          addingSkill != item) ||
                                        (addSkills && isSkillAdded) ||
                                        item?.isAdded
                                      }
                                    >
                                      <div>
                                        {item?.isAdded ? (
                                          <CheckIconBlue />
                                        ) : addSkills && isSkillAdded ? (
                                          <CheckIconGreen />
                                        ) : (
                                          <CheckIconGrey />
                                        )}
                                      </div>
                                      <SkillHeading
                                        color={
                                          item?.isAdded ? '#3249D7' : '#343E59'
                                        }
                                      >
                                        {item?.name}
                                      </SkillHeading>
                                      {item?.isAdded ? null : addSkills &&
                                        isSkillAdded ? (
                                        <AddedSkillHeading
                                          style={{
                                            display: 'inline',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          Added
                                        </AddedSkillHeading>
                                      ) : (
                                        <AddSkillHeading
                                          onClick={() =>
                                            !addSkillDisable &&
                                            handleAddSkillClick(item)
                                          }
                                          isAdded={addingSkill === item}
                                          disable={
                                            addSkillDisable &&
                                            addingSkill != item
                                          }
                                          style={{
                                            display: 'inline',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          + Add Skill
                                        </AddSkillHeading>
                                      )}
                                    </TopHeading>
                                  </ExtraPaddingLeftSkill>
                                )
                              }
                            )}

                            <ExtraPaddingNew />

                            {hasNonEmptySkillSet &&
                              eligibleList?.skills?.otherMandatory?.length >
                                0 && (
                                <SkillsSubHeading>
                                  Other Mandatory Skills
                                </SkillsSubHeading>
                              )}

                            {hasNonEmptySkillSet &&
                              eligibleList?.skills?.otherMandatory?.map(
                                (skillset, index) => (
                                  <div key={index + 'skillSet'}>
                                    <ExtraPaddingLeftSkill>
                                      <SkillSetHeading
                                        style={{ display: 'inline' }}
                                      >{`Skill Set ${
                                        index + 1
                                      }`}</SkillSetHeading>
                                      {skillset?.type == 'AND' &&
                                      skillset?.skills?.length > 1 ? (
                                        <CountHeading
                                          style={{ display: 'inline' }}
                                        >
                                          (All {skillset?.skills?.length} skills
                                          are mandatory)
                                        </CountHeading>
                                      ) : skillset?.type == 'OR' &&
                                        skillset?.skills?.length > 1 ? (
                                        <CountHeading
                                          style={{ display: 'inline' }}
                                        >
                                          (Any 1 skill is mandatory)
                                        </CountHeading>
                                      ) : skillset?.skills?.length == 1 &&
                                        (skillset?.type == 'AND' ||
                                          skillset?.type == 'OR') ? (
                                        <CountHeading
                                          style={{ display: 'inline' }}
                                        >
                                          (The below skill is mandatory)
                                        </CountHeading>
                                      ) : (
                                        ''
                                      )}
                                    </ExtraPaddingLeftSkill>
                                    <ExtraPaddingSkills />

                                    {skillset?.skills?.map(
                                      (item, itemIndex) => {
                                        const isSkillAdded =
                                          addedAllSkills.some(
                                            addedItem =>
                                              addedItem?.id === item?.id
                                          )

                                        return (
                                          <ExtraPaddingLeftSkill1
                                            key={itemIndex + 'skillset'}
                                          >
                                            <TopHeading
                                              isAdded={
                                                addingSkill === item &&
                                                add === false
                                              }
                                              disable={
                                                (addSkillDisable &&
                                                  addingSkill !== item) ||
                                                (addSkills && isSkillAdded) ||
                                                item?.isAdded
                                              }
                                            >
                                              <div>
                                                {item?.isAdded ? (
                                                  <CheckIconBlue />
                                                ) : addSkills &&
                                                  isSkillAdded ? (
                                                  <CheckIconGreen />
                                                ) : (
                                                  <CheckIconGrey />
                                                )}
                                              </div>
                                              <SkillHeading
                                                color={
                                                  item?.isAdded
                                                    ? '#3249D7'
                                                    : '#343E59'
                                                }
                                              >
                                                {item?.name}
                                              </SkillHeading>
                                              {item?.isAdded ? null : addSkills &&
                                                isSkillAdded ? (
                                                <AddedSkillHeading
                                                  style={{
                                                    display: 'inline',
                                                    whiteSpace: 'nowrap',
                                                  }}
                                                >
                                                  Added
                                                </AddedSkillHeading>
                                              ) : (
                                                <AddSkillHeading
                                                  onClick={() =>
                                                    addSkillDisable === false &&
                                                    handleAddSkillClick(item)
                                                  }
                                                  isAdded={addingSkill === item}
                                                  disable={
                                                    addSkillDisable &&
                                                    addingSkill !== item
                                                  }
                                                  style={{
                                                    display: 'inline',
                                                    whiteSpace: 'nowrap',
                                                  }}
                                                >
                                                  + Add Skill
                                                </AddSkillHeading>
                                              )}
                                            </TopHeading>
                                          </ExtraPaddingLeftSkill1>
                                        )
                                      }
                                    )}
                                    <ExtraPaddingSkills />
                                  </div>
                                )
                              )}
                          </>
                        )}

                        {!skillVisible && !locationVisible && (
                          <HorizontalDivider style={{ marginBottom: '20px' }} />
                        )}

                        <div style={{ marginTop: 'auto' }}>
                          <div style={{ paddingLeft: '5px' }}>
                            {!locationVisible &&
                              !(
                                eligibleList?.locations?.studentIsAnyWhere ||
                                eligibleList?.locations?.roleLocationAyWhere ||
                                allLocationsAdded
                              ) && (
                                <>
                                  <SkillsHeading>Location</SkillsHeading>
                                  <LocationDescription>
                                    This role requires {requiredLocations} as
                                    job location, but your preferred location is{' '}
                                    {preferredLocationsString}
                                  </LocationDescription>
                                  <LocationNote>
                                    NOTE : Please add your preferred location
                                  </LocationNote>
                                  <CheckboxSelectAll
                                    value={checked}
                                    onChange={handleCheck}
                                    label={'Select All'}
                                    disabled={addSkillDisable}
                                  />

                                  <FilterCheckBoxComp
                                    value={selectedLocation}
                                    options={locationList}
                                    onChange={onCheckboxLocation}
                                    valueParam="id"
                                    labelParam="name"
                                    disabled={addSkillDisable}
                                  />
                                </>
                              )}
                          </div>

                          {!locationVisible && !expVisible && (
                            <HorizontalDivider
                              style={{
                                marginTop: '12px',
                                marginBottom: '20px',
                              }}
                            />
                          )}

                          <div style={{ paddingLeft: '5px' }}>
                            {!skillVisible &&
                              locationVisible &&
                              !expVisible && (
                                <HorizontalDivider
                                  style={{
                                    marginTop: '12px',
                                    marginBottom: '20px',
                                  }}
                                />
                              )}
                            {console.log(
                              eligibleList?.experience?.isExpCandidate,
                              ' : :eligibleList?.experience?.isExpCandidate'
                            )}
                            {!expVisible && (
                              <>
                                <ExperienceDescription>
                                  This role requires {experienceFromDate} -{' '}
                                  {experienceToDate} years of experience, but
                                  you have {studentExperience} years of
                                  experience.
                                </ExperienceDescription>

                                <ButtonLocal
                                  disabled={
                                    studentExperience >= experienceFromDate ||
                                    addSkillDisable
                                  }
                                >
                                  <Control
                                    alignCenter
                                    gap="10px"
                                    onClick={click}
                                  >
                                    <AdjustIcon>
                                      <AddIcon />
                                    </AdjustIcon>
                                    <Text>Add Experience</Text>
                                  </Control>
                                </ButtonLocal>

                                {studentExperience >= experienceFromDate &&
                                  studentExperience <= experienceToDate && (
                                    <ExperienceNote>
                                      You meet the work experience eligibility
                                      criteria for this job with your{' '}
                                      {studentExperience} years of experience.
                                    </ExperienceNote>
                                  )}

                                {studentExperience > experienceToDate && (
                                  <ExperienceNote>
                                    You exceed the required experience for this
                                    job with your {studentExperience} years of
                                    experience.
                                  </ExperienceNote>
                                )}
                              </>
                            )}

                            <ExtraPaddingLast />
                          </div>
                        </div>
                      </div>
                    </ContentStyle>

                    <FooterFixed>
                      <HorizontalDividerTitle
                        style={{ marginBottom: '12px' }}
                      />

                      <FlexWrapRole gap="20px" right>
                        <>
                          <Button.Secondary text="Cancel" onClick={onClear} />
                          <Button.Primary
                            onClick={SubmitDataLocation}
                            form={formId}
                            text={'Update and Apply'}
                            disabled={
                              !(
                                combinedArrayLocation?.length > 0 ||
                                addSkills ||
                                expDrawer
                              )
                            }
                          />
                        </>
                      </FlexWrapRole>
                    </FooterFixed>
                  </div>

                  <VerticalDivider type="vertical" />
                </>
              )}

              {added && (
                <CarouselContainer style={{ width: '50%' }}>
                  <HeaderFixedNew>
                    <Control column gap="10px">
                      <FlexWrapRole spaceBetween>
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: '16px',
                            lineHeight: '25px',
                            color: '#343E59',
                          }}
                        >
                          {'Add Relevant Experience'}
                        </div>
                        <StyledDiv onClick={onClearSkill}>
                          <CrossIconSkill />
                        </StyledDiv>
                      </FlexWrapRole>

                      <HorizontalDividerTitle style={{ marginTop: '12px' }} />
                      <div style={{ paddingRight: '35px', paddingTop: '15px' }}>
                        <Control row gap="20px">
                          <SpeakerIcon />
                          <Control column gap="10px">
                            <UpdateContent>
                              If your company,project,institute,training course
                              name is not here,please click the button below
                            </UpdateContent>
                            <Link to="/resume">
                              <Button.Primary
                                text={'Update Profile'}
                                width={'120px'}
                                padding={'20px'}
                                height={'35px'}
                              />
                            </Link>
                          </Control>
                        </Control>
                      </div>
                      <HorizontalDividerTitle style={{ marginTop: '12px' }} />
                    </Control>
                  </HeaderFixedNew>
                  <ContentStyleNew>
                    <div style={{ paddingLeft: '30px' }}>
                      <Alert
                        style={{ margin: '10px' }}
                        message=" Note: Add your skills to the experiences where you gained them"
                        type="info"
                      />
                      {roleFloatList?.academics?.length > 0 && (
                        <Checkbox
                          value={educationCheck}
                          label={'Academics'}
                          onChange={handleEducationCheck}
                          list={selectedEdu}
                          options={educationList}
                          onChangeCheck={onCheckboxEdu}
                          valueParam={'id'}
                          labelParam={'educationLevel'}
                        />
                      )}

                      <ExtraPadding />

                      {roleFloatList?.workExperience?.length > 0 && (
                        <Checkbox
                          value={workCheck}
                          label={'Work Experience'}
                          onChange={handleWorkCheck}
                          list={selectedWork}
                          options={workList}
                          onChangeCheck={onCheckboxWork}
                          valueParam="id"
                          labelParam="organization"
                        />
                      )}

                      <ExtraPadding />

                      {roleFloatList?.internships?.length > 0 && (
                        <Checkbox
                          value={internCheck}
                          label={'Internship'}
                          onChange={handleInternshipCheck}
                          list={selectedIntern}
                          options={internList}
                          onChangeCheck={onCheckboxIntern}
                          valueParam="id"
                          labelParam="organization"
                        />
                      )}

                      <ExtraPadding />

                      {roleFloatList?.courses?.length > 0 && (
                        <Checkbox
                          value={trainingCheck}
                          label={'Training course'}
                          onChange={handleTrainingCheck}
                          list={selectedTraining}
                          options={trainingList}
                          onChangeCheck={onCheckboxTraining}
                          valueParam="id"
                          labelParam="title"
                        />
                      )}

                      <ExtraPadding />

                      {roleFloatList?.projects?.length > 0 && (
                        <Checkbox
                          value={projectCheck}
                          label={'Project'}
                          onChange={handleProjectCheck}
                          list={selectedProject}
                          options={projectList}
                          onChangeCheck={onCheckboxProject}
                          valueParam="id"
                          labelParam="title"
                        />
                      )}
                    </div>
                  </ContentStyleNew>

                  <FooterFixed>
                    <HorizontalDividerTitle style={{ marginBottom: '12px' }} />
                    <FlexWrapRole gap="20px" right>
                      <Button.Secondary text="Close" onClick={onClearSkill} />
                      <Button.Primary
                        form={formId}
                        text={'Add'}
                        onClick={SubmitDataSkill}
                        disabled={
                          !(
                            (educationCheck && selectedEdu?.length > 0) ||
                            (internCheck && selectedIntern?.length > 0) ||
                            (trainingCheck && selectedTraining?.length > 0) ||
                            (projectCheck && selectedProject?.length > 0) ||
                            (workCheck && selectedWork?.length > 0)
                          )
                        }
                      />
                    </FlexWrapRole>
                  </FooterFixed>
                </CarouselContainer>
              )}
            </div>
          </>
        )}
      </>
    )
  }

  return (
    <StyledDrawerSkill
      width={added ? '80%' : '40%'}
      padding="0px"
      placement="right"
      visible={roleDrawer}
      content={content()}
    />
  )
}

export default SkillBasedRoleDrawer
